<template>
    <div>
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/3 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.quizname') }}</label>
                    <vs-input class="w-full" v-model="schoolQuizName" name="examName" v-validate="'required'" />
                    <span class="text-danger text-sm">{{ errors.first('examName') }}</span>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.category') }}</label>
                    <v-select class="" v-model="selectCategory" :options="categoryOptions" :clearable="false"
                              :reduce="(option) => option.value" @input="getTopicByaAtegory" :disabled="isSelect">
                        <span slot="no-options"> {{ $t('menuOrganization.emptyList') }} </span>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.typeOfExercise') }}</label>
                    <v-select class="" v-model="quizType" :clearable="false" :options="quizTypeOptions"
                        :reduce="(option) => option.value" disabled>
                    </v-select>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-4" >
                    <label class="vs-input--label">{{ $t('dashboard.times') }}</label>
                    <vs-input class="w-full" type="number" v-model="duration" name="examTime" v-validate="'required'" />
                    <span class="text-danger text-sm">{{ errors.first('examTime') }}</span>
                </div>
                <div class="vx-col md:w-1/3 w-full mt-4">
                    <label class="vs-input--label">{{ $t('multipleChoice.level') }}</label>
                    <v-select class="" v-model="valuePriority" :clearable="false" :options="priorityOptions"
                        :reduce="(option) => option.value" name="Level" v-validate="'required'">
                    </v-select>
                    <span class="text-danger text-sm">{{ errors.first('Level') }}</span>
                </div>
            </div>
        </div>
        <div class="vx-card p-6 mt-4 ">
            <div class="vc-row">
                <div class="vx-col md:w-1/5 w-full">
                    <label class="vs-input--label">{{ $t('multipleChoice.topic') }}</label>
                    <v-select class="" v-model="valueTopic" :clearable="false" :options="topicOptions"
                        :reduce="(option) => option.value" @input="ShowDataQuestion(valueTopic)">
                    </v-select>
                </div>
                <div class="flex items-center mt-8" v-if="this.valueTopic">
                    <vs-checkbox  @change="moveAllToColumn2" v-model="checkBox"></vs-checkbox>
                    <label class="vs-input--label">{{ $t('multipleChoice.allQuestions') }}</label>
                </div>
                <div class="flex space-x-4 pt-6 ">
                    <div class="vx-col w-1/2">
                        <label class="vs-input--label mb-8 block">{{ $t('multipleChoice.listQuestions') }}</label>
                        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
                            :settings="settings" :key="$vs.rtl">
                            <draggable v-model="column1" :group="column1Group" ghost-class="opacity-50"
                                class="drop-zone-1 flex-1 p-4 border border-gray-300 rounded-lg shadow-md bg-white"
                                @start="handleDragStart" @end="handleDragEnd">
                                <div v-for="(item, index) in column1" :key="item.id" :data-id="item.id"
                                    class="p-3 mb-3 border border-gray-200 rounded-lg bg-gray-50 shadow-sm"
                                    :class="{ 'opacity-50': item.disabled }">
                                    <label class="vs-input--label required">{{ $t('multipleChoice.question') }} {{ index + 1 }}:</label>
                                    <div style="border: 2px double #ede8ea;" class="p-4">{{ item.label }}</div>
                                </div>
                            </draggable>
                        </VuePerfectScrollbar>

                    </div>
                    <div class="vx-col w-1/2">

                        <label class="vs-input--label mb-8 block">{{ $t('multipleChoice.ListSelectedQuestions') }} </label>
                        <VuePerfectScrollbar ref="mainSidebarPs" class="scroll-area--nofications-dropdown p-0 mb-10"
                            :settings="settings" :key="$vs.rtl">
                            <draggable v-model="column2" :group="{ name: 'columns', put: true }"
                                ghost-class="opacity-50"
                                class="drop-zone  flex-1 p-4 border border-gray-300 rounded-lg shadow-md bg-white">
                                <div v-for="(item, index) in column2" :key="item.id" :data-id="item.id"
                                    class="p-3 mb-3 border border-gray-200 rounded-lg bg-gray-50 shadow-sm">
                                    <label class="vs-input--label required">{{ $t('multipleChoice.question') }} {{ index + 1 }}:</label>
                                    <div style="border: 2px double #ede8ea;" class="p-4">{{ item.label }}
                                        <vx-tooltip style="float: right;" :text="$t('button.delete')">
                                            <feather-icon icon="XIcon" style="float: right;"
                                                class="icon-btn mt-1 text-danger cursor-pointer" svg-classes="h-5 w-5"
                                                @click="deleteOption(index)">
                                            </feather-icon>
                                        </vx-tooltip>
                                    </div>
                                </div>
                            </draggable>
                        </VuePerfectScrollbar>

                    </div>
                </div>
                <div class="flex justify-between">
                    <div class="vx-row mt-4">
                        <div class="vx-col w-full mt-2.5">
                            <div class="mt-2 flex flex-wrap items-center justify-end mb-2">
                                <vs-button class="mr-5" color="danger" @click="back">{{ $t('multipleChoice.back') }}
                                </vs-button>
                                <vs-button class="" type="border" @click="saveAddQuestionTopic">{{ this.questionId ?
                        $t('multipleChoice.updated') : $t('multipleChoice.created')}}
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import draggable from 'vuedraggable';
import 'flatpickr/dist/flatpickr.css';
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
export default {
    components: {
        vSelect,
        draggable,
        VuePerfectScrollbar
    },
    data() {
        return {
            checkBox:false,
            valuePriority: null,
            priorityOptions: [
            { value: 1, label: this.$t('multipleChoice.easy')},
                { value: 2, label: this.$t('multipleChoice.moderate') },
                { value: 3, label: this.$t('multipleChoice.difficult') },
            ],
            quizTypeOptions: [
                { value: 2, label: this.$t('multipleChoice.multiple_choice_exercises') },
            ],
            pageNumber: 0,
            pageSize: 20,
            topicOptions: [],
            categoryOptions:[],
            schoolQuizName: null,
            duration: null,
            points: null,
            valueTopic: null,
            quizType: {value: 2, label: this.$t('multipleChoice.multiple_choice_exercises') },
            selectCategory:null,
            questions: [],
            column1: [
            ],
            column2: [
            ],
            dataBackColumn2: [],
            questionId: null,
            dataBack: null,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .60,
            },
            isSelect:null,


        }
    },
    computed: {
        column1Group() {
            return {
                name: 'columns',
                pull: (item) => item.disabled ? false : 'clone',
                put: false
            };
        },
        validateForm() {
            return !this.errors.any()
        },
    },
    created() {
        this.questionId = this.$route.query.questionId;
        if (this.questionId) {
            this.getDataBack();
            this.isSelect = true;
        }
        this.getCategory();

    },
    methods: {
        validateNumberInput(event) {
            const value = event.target.value;
            const integerPattern = /^\d*$/;

            if (integerPattern.test(value)) {
                this.points = value;
            } else {
                this.points = this.points.slice(0, -1);
            }
        },
        moveAllToColumn2() {
            if(this.checkBox){
                const existingIds = new Set(this.column2.map(item => item.questionId));
                const itemsToAdd = this.column1.filter(item => !existingIds.has(item.questionId));
                this.column2 = [...this.column2, ...itemsToAdd];
            }

        },
        deleteOption(index) {
            this.column2.splice(index, 1)
        },
        back() {
            history.back()
        },
        getTopicByaAtegory(){
            if (this.selectCategory){
                this.isSelect = true;
            }
            this.getTopic();
            this.valueTopic = null
        },
        handleDragEnd(event) {
            // const addedItem = event.item._underlying_vm_;
            const uniqueData = this.column2.filter((item, index, self) =>
                index === self.findIndex((t) => (
                    t.questionId === item.questionId
                ))
            );
            if (uniqueData.length < this.column2.length) {
                this.column2 = uniqueData,
                    this.$vs.notify({
                        text: this.$t('multipleChoice.questionExists'),
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                    })
                return
            } else return
        },

        handleDragStart(event) {
            const addedItem = event.item._underlying_vm_;
            if (addedItem.disabled === true) {
                event.preventDefault();
            }
        },
        ShowDataQuestion(valueTopic) {
            this.getTopic(valueTopic);

        },
        getCategory() {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,

            }
            this.$crm.post('/school-quiz-category/find-by-condition', body).then((response) => {
                this.categoryOptions = response.data.content.map(el => {
                    return {
                        label: el.categoryName,
                        value: el.id
                    }
                })
            })
        },
        getDataBack() {
            this.$vs.loading();
            this.$crm.post(`/school-quiz/find-by-id/${this.questionId}`).then((response) => {
                this.dataBack = response.data
                if (this.questionId) {
                    this.schoolQuizName = this.dataBack.schoolQuizName
                    this.duration = this.dataBack.duration
                    this.points = this.dataBack.points
                    this.valuePriority = this.dataBack.levelType
                    this.quizType = this.dataBack.quizType
                    this.selectCategory = this.dataBack.categoryId
                    let questionsData = this.dataBack.questions

                    for (const key in questionsData) {
                        this.questions.push(questionsData[key])
                        this.column2 = this.questions.map(el => {
                            return {
                                label: el.questionName,
                                questionId: el.id,
                                disabled: false
                            }
                        })

                    }
                }
                if(this.selectCategory){
                    this.getTopic()
                }
                this.$vs.loading.close();
            })
        },
        getTopic(valueTopic) {
            let body = {
                pageNumber: this.pageNumber,
                pageSize: this.pageSize,
                categoryId:this.selectCategory
            }
            this.$vs.loading();
            this.$crm.post('/school-quiz-topic/find-by-condition', body).then((response) => {
                if (valueTopic) {
                    this.column1 = response.data.content.find(el => el.id == valueTopic).questions.map(x => {
                        return {
                            questionId: x.id,
                            label: x.questionName,
                            disabled: false
                        }
                    })
                }
                this.topicOptions = response.data.content.map(el => {
                    return {
                        value: el.id,
                        label: el.topicName
                    }

                })
                this.$vs.loading.close();
            })
        },
        async saveAddQuestionTopic(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;
            this.column2.map(el => {
                el.orders = this.column2.indexOf(el) + 1;
            })
            if (this.column2.length < 1) {
                return this.$vs.notify({
                    text: 'Vui lòng lựa chọn câu hỏi',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'warning',
                });
            }
            let body = {
                schoolQuizName: this.schoolQuizName,
                duration: this.duration,
                points: this.points,
                levelType: this.valuePriority,
                questions: this.column2,
                quizType: 2,
                categoryId: this.selectCategory,
            }
            let url = this.questionId ? `/school-quiz/update/${this.questionId} ` : '/school-quiz/create'
            this.$vs.loading();
            this.$crm.post(url, body).then((response) => {
                this.$vs.loading.close();
                this.$router.push(`/user/multiple-choice-exercises`);
                if (this.questionId) {
                    return this.$vs.notify({
                        text: 'Cập nhật bài thi thành công',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'success',
                    });
                } else return this.$vs.notify({
                    text: 'Thêm mới bài thi thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                });

            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        }
    },
}
</script>
<style>
.drop-zone-1 {
    min-height: 40px;
    border: 2px dashed #cccccc;
}

.drop-zone {
    position: relative;
    border: 2px dashed #cccccc;
    background-color: #f9f9f9;
    min-height: 40px;
    overflow: hidden;
}

.drop-zone::before {
    content: "Kéo câu hỏi vào đây";
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: #cccccc;
    font-size: 16px;
    font-style: italic;
}

.drop-zone .dragging-item {
    position: absolute;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 1;
}
</style>
